import { captureEvent } from "./posthog";

export function trackViewProduct(product, extra = {}) {
  if (!product) return;
  captureEvent("view_product", {
    product_id: String(product._id ?? product.id ?? ""),
    product_name: product.name,
    vendor_id: String(product.vendorId ?? product.vendor ?? ""),
    price: product.price,
    ...extra,
  });
}

export function trackAddToCart(product, opts = {}) {
  if (!product) return;
  captureEvent("add_to_cart", {
    product_id: String(product._id ?? product.id ?? ""),
    product_name: product.name,
    vendor_id: String(product.vendorId ?? product.vendor ?? ""),
    variant_option_id: opts.variantOptionId || "",
    quantity: opts.quantity ?? 1,
  });
}

export function trackBeginCheckout({ cartValue, itemCount, vendorId, storeSlug }) {
  captureEvent("begin_checkout", {
    cart_value: cartValue,
    item_count: itemCount,
    vendor_id: vendorId ? String(vendorId) : "",
    store_slug: storeSlug || "",
  });
}

export function trackOrderCompleted({
  orderId,
  value,
  paymentMethod,
  itemCount,
  vendorId,
}) {
  captureEvent("order_completed", {
    order_id: String(orderId ?? ""),
    value,
    payment_method: paymentMethod,
    item_count: itemCount,
    vendor_id: vendorId ? String(vendorId) : "",
  });
}

export function trackUserSignedUp({ method = "email" } = {}) {
  captureEvent("user_signed_up", { method });
}

export function trackUserLoggedIn({ method = "email" } = {}) {
  captureEvent("user_logged_in", { method });
}
